import { jsx as _jsx } from "react/jsx-runtime";
export function withNonTrellisComponent() {
  return function (Component) {
    return function (props) {
      const newProps = Object.assign({}, props, {
        isTrellisCompatibleComponent: false
      });
      return /*#__PURE__*/_jsx(Component, Object.assign({}, newProps));
    };
  };
}
export function withTrellisComponent() {
  return function (Component) {
    return function (props) {
      const newProps = Object.assign({}, props, {
        isTrellisCompatibleComponent: true
      });
      return /*#__PURE__*/_jsx(Component, Object.assign({}, newProps));
    };
  };
}